import { get } from "lodash";
import { all, put, select, takeLatest } from "redux-saga/effects";
import history from "~/history";
import { client } from "~/utils/medproSDK";
import { SET_FILTER_CHECK_DATA } from "../totalData/types";
import * as types from "./types";

function* requestGetNextStep({ payload }) {
  try {
    const { plattform } = payload;
    const total = yield select(state => state.totalData);
    const patient = yield select(state => state.patient);
    const partnerid = get(total, "partnerId");

    const objCheckFilter = {
      treeId: total.treeId,
      stepId: "CheckBHYT",
      serviceId: total.service.id,
      template: "INSURANCE",
      hasInsurance: true,
      isValid: true
    };

    const response1 = yield client.checkFilter(
      { ...objCheckFilter },
      { partnerid }
    );
    const { data } = response1;

    // ----------> app
    const obj = {
      sessionId: plattform === "app" ? payload.id : data.id || "",
      sessionData: {
        ...payload,
        insuranceCode: patient.selectedPatient.insuranceCode,
        hasInsuranceCode:
          total.service.serviceType === total.service.serviceTypeDefault
      }
    };

    const rs = yield client.getNextStep(
      {
        ...obj
      },
      {
        partnerid
      }
    );

    yield put({
      type: SET_FILTER_CHECK_DATA,
      id: rs.data.id
    });

    const { origin, pathname } = window.location;
    if (plattform === "app") {
      // app thì đổi url
      if (!pathname.includes("confirm")) {
        const index = pathname.indexOf("-app");
        const webUrl = `${pathname.slice(0, index + 4)}-confirm${pathname.slice(
          index + 4
        )}`;
        const url = `${origin}${webUrl}`;
        console.log("url :>> ", url);
        window.location.href = url;
        history.push(webUrl);
      }
    } else {
      console.log("web đá về home");
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* watcher() {
  yield all([takeLatest(types.FILTER_GET_NEXT_STEP, requestGetNextStep)]);
}
